import Vue from 'vue';
import { platform, version } from '@/common/bridge';
import * as Types from '@/common/types';

export const EventBus = new Vue();

export let isArticleOpen = false;
export let isMyRequestOpen = false;

// OpenArticle
export const emitOpenArticle = (data: Types.ArticleEvent) => {
  isArticleOpen = data.isOpen;
  EventBus.$emit('OpenArticle', { ...data });
};

export const onOpenArticle = (callback: (data: Types.ArticleEvent) => void) => {
  EventBus.$on('OpenArticle', callback);
};

// MyRequest: true, false
export const emitOpenMyRequest = (isOpen: boolean) => {
  isArticleOpen = isOpen;
  EventBus.$emit('OpenMyRequest', isOpen);
};

export const onOpenMyRequest = (callback: (isOpen: boolean) => void) => {
  EventBus.$on('OpenMyRequest', callback);
};

export const emitFloatButton = (isOpen: boolean) => {
  if (!version || (platform === 'app' || platform === 'ios')) return;
  EventBus.$emit('OpenFloatButton', isOpen);
};

export const onFloatButton = (callback: (isOpen: boolean) => void) => {
  EventBus.$on('OpenFloatButton', callback);
};
